module.exports = __webpack_public_path__ + "img/0-23.67097d11.jpg";